/*
  pf-gallery.js — Galerie des Hauptbildes auf der Produktseite.
  Gehört zu sections/pf-buybox.liquid: Markup und Styles stehen dort,
  die Bewegung hier. Wird nach pf-script.js geladen, damit dessen
  Klick-Handler für die Miniaturen schon hängt.
*/
  /* Galerie des Hauptbildes: Pfeile, Wischen mit Vorschau, Vollbild mit Zoom.

     Grundsatz wie bisher: Was im großen Bild landet, entscheidet weiterhin
     allein der Klick-Handler in pf-script.js. Pfeile und Wischgeste klicken
     nur die passende Miniatur an — es gibt keine zweite Wahrheit darüber,
     welches Medium gerade dran ist.

     setTimeout(0) beim Aktualisieren der Zahl: pf-script.js setzt die Klasse
     is-active in seinem eigenen Handler. Erst danach stimmt der Stand, den wir
     hier ablesen — unabhängig davon, welcher Handler zuerst hängt. */
  (function () {
    var GAP = 14;        /* Abstand zwischen Haupt- und Vorschaubild */
    var DUR = 280;       /* Dauer der Wisch-Animation in ms */

    function init() {
      var root = document.querySelector('[data-pf-root]');
      if (!root) { return; }

      var rows = root.querySelector('[data-pf-media-rows]');
      var hero = root.querySelector('.pf-hero');
      var heroImg = root.querySelector('[data-pf-hero-img]');
      if (!rows || !hero || !heroImg) { return; }

      var thumbs = Array.prototype.slice.call(rows.querySelectorAll('[data-pf-thumb]'));
      if (!thumbs.length) { return; }

      var inner = heroImg.parentElement;
      var peekPrev = root.querySelector('[data-pf-hero-peek="prev"]');
      var peekNext = root.querySelector('[data-pf-hero-peek="next"]');
      var nav = root.querySelector('[data-pf-media-nav]');
      var posEl = nav ? nav.querySelector('[data-pf-media-pos]') : null;
      var multi = thumbs.length > 1;

      function current() {
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].classList.contains('is-active')) { return i; }
        }
        return 0;
      }
      function isVideo(i) { return thumbs[i].getAttribute('data-video') === '1'; }
      function bigSrc(i) {
        var t = thumbs[i];
        var s = t.getAttribute('data-src');
        if (s) { return s; }
        var im = t.querySelector('img');
        return im ? im.src : '';
      }
      /* Alt-Text des Hauptbildes mitziehen.

         Zwei Wege fuehren zu einem neuen Bild: ein Klick auf eine Miniatur und
         ein Farbwechsel im Farbfinder (den setzt pf-script.js direkt auf
         heroImg.src). Statt beide Wege einzeln abzufangen, beobachten wir das
         src-Attribut und schlagen den passenden Alt-Text in den Miniaturen
         nach. So bleibt es auch dann richtig, wenn pf-script.js sich aendert. */
      var altVonSrc = {};
      thumbs.forEach(function (t) {
        var s = t.getAttribute('data-src');
        var a = t.getAttribute('data-alt');
        if (s && a) { altVonSrc[s] = a; }
      });
      function syncAlt() {
        var a = altVonSrc[heroImg.getAttribute('src')];
        if (a) { heroImg.alt = a; }
      }
      /* Welches Medium liegt wirklich im grossen Bild?

         Nicht immer das mit der Markierung is-active: beim Farbwechsel setzt
         pf-script.js nur heroImg.src und laesst die Miniaturen unberuehrt.
         Wer danach aufs Bild tippte, bekam im Vollbild das zuletzt geklickte
         Bild statt der gewaehlten Farbe. Deshalb zuerst ueber die Quelle
         suchen und nur hilfsweise auf die Markierung zurueckfallen. */
      function heroIndex() {
        var s = heroImg.getAttribute('src');
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].getAttribute('data-src') === s) { return i; }
        }
        return current();
      }
      if (window.MutationObserver) {
        new MutationObserver(syncAlt).observe(heroImg, { attributes: true, attributeFilter: ['src'] });
      }

      function refresh() {
        setTimeout(function () {
          if (posEl) { posEl.textContent = current() + 1; }
        }, 0);
      }
      function commit(step) {
        var i = (current() + step + thumbs.length) % thumbs.length;
        thumbs[i].click();
        thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        refresh();
      }

      /* ─── Wischen mit Vorschau ─── */
      var slideW = 0;
      var busy = false;

      function layoutPeeks() {
        var r = heroImg.getBoundingClientRect();
        var ir = inner.getBoundingClientRect();
        [peekPrev, peekNext].forEach(function (el) {
          el.style.left = (r.left - ir.left) + 'px';
          el.style.top = (r.top - ir.top) + 'px';
          el.style.width = r.width + 'px';
          el.style.height = r.height + 'px';
        });
        return r.width;
      }
      function setOffset(dx, animate) {
        var t = animate ? ('transform ' + DUR + 'ms cubic-bezier(.22,.61,.36,1)') : 'none';
        heroImg.style.transition = t;
        heroImg.style.transform = 'translateX(' + dx + 'px)';
        peekPrev.style.transition = t;
        peekPrev.style.transform = 'translateX(' + (dx - slideW - GAP) + 'px)';
        peekNext.style.transition = t;
        peekNext.style.transform = 'translateX(' + (dx + slideW + GAP) + 'px)';
      }
      function armPeeks() {
        slideW = layoutPeeks();
        var n = thumbs.length;
        var c = current();
        peekPrev.src = bigSrc((c - 1 + n) % n);
        peekNext.src = bigSrc((c + 1) % n);
        peekPrev.style.opacity = '1';
        peekNext.style.opacity = '1';
        setOffset(0, false);
      }
      function clearPeeks() {
        peekPrev.style.opacity = '0';
        peekNext.style.opacity = '0';
        setOffset(0, false);
        heroImg.style.transition = 'none';
        heroImg.style.transform = '';
      }
      /* Animiert in die Zielrichtung und übergibt dann an pf-script.js.

         Kein requestAnimationFrame: in einem Tab im Hintergrund feuert rAF
         gar nicht. Wer dort einen Pfeil antippt und die App wechselt, hätte
         die Galerie dauerhaft blockiert — busy wäre nie wieder false
         geworden. Ein erzwungener Layout-Durchlauf (offsetWidth lesen) setzt
         den Ausgangswert genauso zuverlässig, und setTimeout läuft auch im
         Hintergrund weiter. */
      function slideTo(step) {
        if (busy || !multi) { return; }
        busy = true;
        armPeeks();
        void heroImg.offsetWidth;
        setOffset(-step * (slideW + GAP), true);
        setTimeout(function () {
          commit(step);
          clearPeeks();
          busy = false;
        }, DUR + 10);
      }

      var decided = false, horizontal = false;

      if (multi && nav && peekPrev && peekNext) {
        var totalEl = nav.querySelector('[data-pf-media-total]');
        if (totalEl) { totalEl.textContent = thumbs.length; }
        nav.classList.add('is-on');

        var prevBtn = nav.querySelector('[data-pf-media-prev]');
        var nextBtn = nav.querySelector('[data-pf-media-next]');
        if (prevBtn) { prevBtn.addEventListener('click', function () { slideTo(-1); }); }
        if (nextBtn) { nextBtn.addEventListener('click', function () { slideTo(1); }); }
        rows.addEventListener('click', refresh);
        refresh();

        var sx = 0, sy = 0, moved = 0, t0 = 0;
        var dragging = false;

        hero.addEventListener('touchstart', function (e) {
          if (busy || e.touches.length !== 1) { dragging = false; return; }
          if (e.target.closest && e.target.closest('[data-pf-hero-video-wrap]')) { dragging = false; return; }
          dragging = true; decided = false; horizontal = false; moved = 0;
          sx = e.touches[0].clientX;
          sy = e.touches[0].clientY;
          t0 = Date.now();
          armPeeks();
        }, { passive: true });

        hero.addEventListener('touchmove', function (e) {
          if (!dragging || e.touches.length !== 1) { return; }
          var dx = e.touches[0].clientX - sx;
          var dy = e.touches[0].clientY - sy;
          if (!decided) {
            if (Math.abs(dx) < 8 && Math.abs(dy) < 8) { return; }
            decided = true;
            horizontal = Math.abs(dx) > Math.abs(dy);
            /* Senkrecht: Finger weg, die Seite soll scrollen. */
            if (!horizontal) { dragging = false; clearPeeks(); return; }
          }
          moved = dx;
          setOffset(dx * 0.92, false);
        }, { passive: true });

        hero.addEventListener('touchend', function () {
          if (!dragging) { return; }
          dragging = false;
          if (!decided || !horizontal) { clearPeeks(); return; }

          var abs = Math.abs(moved);
          var schnell = abs > 40 && (Date.now() - t0) < 300;
          if (abs > slideW * 0.22 || schnell) {
            var step = moved < 0 ? 1 : -1;
            busy = true;
            setOffset(-step * (slideW + GAP), true);
            setTimeout(function () {
              commit(step);
              clearPeeks();
              busy = false;
            }, DUR + 10);
          } else {
            setOffset(0, true);
            setTimeout(clearPeeks, DUR + 10);
          }
        }, { passive: true });

        hero.addEventListener('touchcancel', function () {
          dragging = false;
          clearPeeks();
        }, { passive: true });

        window.addEventListener('resize', function () {
          if (!busy) { slideW = layoutPeeks(); }
        });
      }

      /* ─── Vollbild ─── */
      var lb = root.querySelector('[data-pf-lb]');
      if (!lb) { return; }
      var stage = lb.querySelector('[data-pf-lb-stage]');
      var lbImg = lb.querySelector('[data-pf-lb-img]');
      var lbPos = lb.querySelector('[data-pf-lb-pos]');
      var lbTotal = lb.querySelector('[data-pf-lb-total]');
      var hint = lb.querySelector('[data-pf-lb-hint]');

      /* Nur Bilder. Ein Video hat seine eigene Steuerung und gehört nicht
         in eine Zoom-Ansicht. */
      var pics = [];
      thumbs.forEach(function (t, i) { if (!isVideo(i)) { pics.push(i); } });
      if (!pics.length) { return; }
      if (lbTotal) { lbTotal.textContent = pics.length; }
      if (pics.length < 2) {
        lb.querySelector('[data-pf-lb-prev]').hidden = true;
        lb.querySelector('[data-pf-lb-next]').hidden = true;
        lb.querySelector('.pf-lb-count').hidden = true;
      }

      var at = 0, sc = 1, tx = 0, ty = 0;

      function fullSrc(k) {
        var t = thumbs[pics[k]];
        return t.getAttribute('data-full') || t.getAttribute('data-src') || '';
      }
      function apply() {
        lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + sc + ')';
      }
      /* Hält das Bild im Rahmen: nie weiter schieben, als über den Rand
         hinausragt. Bei Maßstab 1 ist der Spielraum null. */
      function clampPan() {
        var r = stage.getBoundingClientRect();
        var mx = Math.max(0, (lbImg.clientWidth * sc - r.width) / 2);
        var my = Math.max(0, (lbImg.clientHeight * sc - r.height) / 2);
        tx = Math.min(mx, Math.max(-mx, tx));
        ty = Math.min(my, Math.max(-my, ty));
      }
      function show(k) {
        at = (k + pics.length) % pics.length;
        lbImg.src = fullSrc(at);
        lbImg.alt = thumbs[pics[at]].getAttribute('data-alt') || '';
        sc = 1; tx = 0; ty = 0; apply();
        if (lbPos) { lbPos.textContent = at + 1; }
      }
      function open(heroIdx) {
        var k = pics.indexOf(heroIdx);
        show(k < 0 ? 0 : k);
        lb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        if (hint) {
          hint.removeAttribute('data-off');
          setTimeout(function () { hint.setAttribute('data-off', ''); }, 2600);
        }
      }
      function close() {
        lb.hidden = true;
        document.documentElement.style.overflow = '';
      }

      lb.querySelector('[data-pf-lb-close]').addEventListener('click', close);
      var lbPrevBtn = lb.querySelector('[data-pf-lb-prev]');
      var lbNextBtn = lb.querySelector('[data-pf-lb-next]');
      if (lbPrevBtn) { lbPrevBtn.addEventListener('click', function () { show(at - 1); }); }
      if (lbNextBtn) { lbNextBtn.addEventListener('click', function () { show(at + 1); }); }

      document.addEventListener('keydown', function (e) {
        if (lb.hidden) { return; }
        if (e.key === 'Escape') { close(); }
        if (e.key === 'ArrowLeft') { show(at - 1); }
        if (e.key === 'ArrowRight') { show(at + 1); }
      });

      /* Klick auf das Hauptbild öffnet das Vollbild — aber nicht, wenn die
         Geste ein Wischen war, und nicht auf dem Video. */
      hero.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-pf-hero-video-wrap]')) { return; }
        if (decided && horizontal) { return; }
        if (busy) { return; }
        var c = heroIndex();
        if (isVideo(c)) { return; }
        open(c);
      });

      /* ── Zoom und Schieben ──
         Ein Finger: bei Maßstab 1 blättern, sonst schieben.
         Zwei Finger: zoomen. Der Punkt zwischen den Fingern bleibt dabei
         stehen — dafür wird die Verschiebung nachgeführt:
         t = m − k · (m₀ − t₀), mit k = neuer/alter Maßstab. */
      var p0 = null, pStart = 1, tStart = { x: 0, y: 0 }, mStart = { x: 0, y: 0 };
      var oneX = 0, oneY = 0, oneMoved = 0, panning = false;
      var lastTap = 0;

      function mid(e) {
        var r = stage.getBoundingClientRect();
        var a = e.touches[0], b = e.touches[1];
        return {
          x: (a.clientX + b.clientX) / 2 - (r.left + r.width / 2),
          y: (a.clientY + b.clientY) / 2 - (r.top + r.height / 2)
        };
      }
      function dist(e) {
        var dx = e.touches[0].clientX - e.touches[1].clientX;
        var dy = e.touches[0].clientY - e.touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          p0 = dist(e);
          pStart = sc;
          tStart = { x: tx, y: ty };
          mStart = mid(e);
          panning = false;
        } else if (e.touches.length === 1) {
          p0 = null;
          oneX = e.touches[0].clientX;
          oneY = e.touches[0].clientY;
          oneMoved = 0;
          panning = sc > 1;
        }
      }, { passive: true });

      stage.addEventListener('touchmove', function (e) {
        if (e.touches.length === 2 && p0) {
          var k = Math.min(4, Math.max(1, pStart * (dist(e) / p0))) / pStart;
          var m = mid(e);
          sc = pStart * k;
          tx = m.x - k * (mStart.x - tStart.x);
          ty = m.y - k * (mStart.y - tStart.y);
          clampPan();
          apply();
          e.preventDefault();
        } else if (e.touches.length === 1) {
          var dx = e.touches[0].clientX - oneX;
          var dy = e.touches[0].clientY - oneY;
          oneMoved = Math.abs(dx) + Math.abs(dy);
          if (panning) {
            tx += dx; ty += dy;
            oneX = e.touches[0].clientX;
            oneY = e.touches[0].clientY;
            clampPan();
            apply();
            e.preventDefault();
          }
        }
      }, { passive: false });

      stage.addEventListener('touchend', function (e) {
        if (e.touches.length) { return; }
        var jetzt = Date.now();

        /* Doppeltippen schaltet zwischen Maßstab 1 und 2,5 um. */
        if (oneMoved < 12 && (jetzt - lastTap) < 300) {
          if (sc > 1) { sc = 1; tx = 0; ty = 0; } else { sc = 2.5; }
          clampPan(); apply();
          lastTap = 0;
          return;
        }
        if (oneMoved < 12) { lastTap = jetzt; return; }

        /* Bei Maßstab 1 blättert ein waagerechter Wisch. */
        if (sc === 1 && pics.length > 1) {
          var dx = e.changedTouches[0].clientX - oneX;
          var dy = e.changedTouches[0].clientY - oneY;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            show(at + (dx < 0 ? 1 : -1));
          }
        }
        p0 = null;
        panning = sc > 1;
      }, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
